import { QueryHandler } from '@/redux/types/query-handler';
import { dispatchSuccessPatchAddDeviceToUnit } from './dispatch-success-patch';
import { AddDeviceToUnitQueryArg } from '../types/query-arg';

export const handleResultAddDeviceToUnit: QueryHandler<
  AddDeviceToUnitQueryArg,
  void | string
> = async (queryArg, { queryFulfilled, ...api }) => {
  // endpointId gets updated when device is associated / unassociated
  const { data: updatedEndpointId } = await queryFulfilled;
  if (updatedEndpointId) {
    queryArg = {
      ...queryArg,
      device: {
        ...queryArg.device,
        endpointId: updatedEndpointId,
      },
    };
  }
  dispatchSuccessPatchAddDeviceToUnit(queryArg, api);
};
